<template>
    <TypeaheadInput
        :data="typeaheadList"
        :value="selectedValue"
        :placeholder="placeholder"
        :init-value="selectedValue"
        ref="typeaheadInputRef"
        :showAllByDefault="true"
        :openOnFocus="true"
    />
</template>

<script src="./EnumTypeaheadInput.ts"></script>
